import { applyMiddleware, combineReducers, createStore, Action, compose } from 'redux';
import Login, { LoginState, submitLoginEpic, checkLoginEpic, timeoutEpic } from './login';
import Info, { InfoState, loadFieldsEpic } from './info';
import Profile, { ProfileState, loadProfileEpic } from './profile';
import Photo, { PhotoState, loadPhotosEpic, loadCommEpic, loadCommsEpic, loadParentEpic } from './photos';
import { createEpicMiddleware, combineEpics } from 'redux-observable';
import Webshop, { WebshopState, webshopOnLogin, loadOrders, submitPayment, sendEmail, submitPaypal } from './webshop';

interface DevWindow extends Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any
};

export type RootState = {
    login: LoginState,
    info: InfoState,
    profile: ProfileState,
    photo: PhotoState,
    webshop: WebshopState
}

declare var window: DevWindow;

const rootReducer = combineReducers<RootState>({
    login: Login,
    info: Info,
    profile: Profile,
    photo: Photo,
    webshop: Webshop
})

const epicMiddleware = createEpicMiddleware<Action, Action, RootState>();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(rootReducer,
    composeEnhancers(
        applyMiddleware(epicMiddleware)
    )
);

epicMiddleware.run(combineEpics(
    checkLoginEpic,
    submitLoginEpic,
    timeoutEpic,
    loadFieldsEpic,
    loadProfileEpic,
    loadPhotosEpic,
    loadCommEpic,
    loadCommsEpic,
    loadParentEpic,
    // loadAlbumEpic,
    webshopOnLogin,
    loadOrders,
    submitPayment,
    submitPaypal,
    sendEmail
));